import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Email from "@material-ui/icons/Email";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Button from "@material-ui/core/Button/Button";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { userAction } from "../../actions/user.action";
import ErrorMessage from "../../components/UI/ErrorMessage";
import CenteredContent from "../../components/UI/CenteredContent";

const styles = (theme) => ({
  cta: {
    marginTop: theme.spacing(2),
  },
  backBtn: {
    [theme.breakpoints.down("md")]: {
      fontSize: "12px",
      marginTop: "-2px",
      textTransform: "capitalize",
      float: "right",
      width: "auto",
    },
  },
  form: {
    height: theme.wbiComponent.login.formHeight,
    [theme.breakpoints.down("md")]: {
      height: "auto",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  disabledTab: {
    "&&": {
      color: `${theme.palette.primary.main}`,
    },
  },
});

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      requestSent: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.user.requestPwResetResult !==
      this.props.user.requestPwResetResult
    ) {
      this.setState({ email: "" });
    }
  }

  handleChange = (name) => (e) => {
    e.preventDefault();
    const { value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const result = this.props.dispatch(
      userAction.requestPasswordReset(this.state.email.toLowerCase())
    );
    result.then((response) => {
      if (response && response.success) {
        this.setState({ requestSent: true });
      }
    });
  };

  render() {
    const { classes, user } = this.props;

    return (
      <CenteredContent
        headerContent={
          <Tabs
            value={0}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              label="FORGOT PASSWORD"
              disabled
              classes={{ disabled: classes.disabledTab }}
            />
          </Tabs>
        }
      >
        <div className={classes.form}>
          {this.state.requestSent && user.requestPwResetResult ? (
            <Typography color="primary" variant="body2">
              {user.requestPwResetResult}
            </Typography>
          ) : (
            <form className={classes.form} onSubmit={this.handleSubmit}>
              <div>
                {user.requestPwResetError && (
                  <ErrorMessage>{user.requestPwResetError}</ErrorMessage>
                )}
                <TextField
                  label="Email Address"
                  type="email"
                  onChange={this.handleChange("email")}
                  value={this.state.email}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    ),
                  }}
                  data-cy="forgotPassword.email"
                />
              </div>
              <div>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.cta}
                  disabled={user.requestingPwReset}
                  data-cy="forgotPassword.submit"
                >
                  Send Email
                </Button>
              </div>
            </form>
          )}
          <Link to="/login">
            <Button
              fullWidth
              className={`${classes.cta} ${classes.backBtn} `}
              {...(this.state.requestSent
                ? {
                    variant: "contained",
                    color: "secondary",
                  }
                : {})}
            >
              Back to Login
            </Button>
          </Link>
        </div>
      </CenteredContent>
    );
  }
}

ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withStyles(styles)(connect(mapStateToProps)(ForgotPassword));



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/index.jsx